function getProductFetchUrlStr(url) {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname; // e.g. /products/shape-tape-creamy-concealer
    const origin = parsedUrl.origin; // e.g. https://tarte-prd.myshopify.com
    return `${origin}${pathname}.json`;
  } catch (error) {
    return null;
  }
}

function onQuizComplete() {
  const pairWithSection = document.getElementById("pairWithSection");
  const quizResultContainer = document.querySelector(".octane-ai-quiz-rendered");
  const body = document.querySelector('body');

  body.classList.add('octane-quiz-results-page');

  if (pairWithSection instanceof Node && quizResultContainer instanceof Node) {
    pairWithSection.style.display = "block";

    if (!quizResultContainer.contains(pairWithSection)) {
      quizResultContainer.appendChild(pairWithSection);
    }
  }
}


function insertLimitMessage(productTitle, maxQty) {
  const container = document.querySelector('#octane-quiz-wrapper');
  if (!container) return;

  const existing = container.querySelector('.max-qty-msg');
  if (existing) existing.remove();

  const msg = document.createElement('div');
  msg.className = 'max-qty-msg';
  msg.setAttribute('role', 'alert');
  msg.textContent = `You've already added the maximum allowed quantity (${maxQty}) of ${productTitle} to your cart.`;
  setTimeout(() => {
    container.appendChild(msg);
  })
}

async function getResultProductPrice(productId, country) {
  const prices = await window.fetchProductPrices(String(productId));
  const localizedProductPrice = prices[`_price-${country}`];
  return localizedProductPrice;
}

async function renderPrices(resultProducts, priceElements) {
  const resultProductsArray = Array.isArray(resultProducts) ? resultProducts : [resultProducts];
  const locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';
  const country = window.Shopify && window.Shopify.country ? window.Shopify.country : 'US';
  const currency =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    document.documentElement.getAttribute('data-shopify-currency') ||
    'USD';

  const formatter = new Intl.NumberFormat(locale + '-' + country, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const quizProductTile = document.querySelectorAll('div[data-element="oct-quiz-resultitem"]');

  for (let i = 0; i < resultProductsArray.length; i++) {
    const product = resultProductsArray[i];
    const price   = await getResultProductPrice(String(product.id), country);
    const numeric = parseFloat(String(price).replace(/[^\d.-]/g, ''));
    const isValidPrice = Number.isFinite(numeric);

    const priceInsert = isValidPrice ? formatter.format(numeric) : '-';

    if (priceElements[i]) {
      priceElements[i].textContent = priceInsert;
      if (isValidPrice) resultProductsArray[i].price = priceInsert;
    }
  }

  quizProductTile.forEach((selector, i) => {
    const selectElement = selector.querySelector('select');
    if(!selectElement) return;
    selectElement.addEventListener('change', async () => {
      const product = resultProductsArray[i];
      priceElements[i].setAttribute('data-loading', 'true');
      const price   = await getResultProductPrice(String(product.id), country);
      const numeric = parseFloat(String(price).replace(/[^\d.-]/g, ''));
      const priceInsert = Number.isFinite(numeric) ? formatter.format(numeric) : '-';

      if (priceElements[i]) priceElements[i].textContent = priceInsert;
      priceElements[i].removeAttribute('data-loading');
    })
  })
}

// result page
document.addEventListener(
  "octane.quiz.completed",
  async function(e) {
    onQuizComplete();

    const octaneData = document.querySelector(".octane-data");
    const shouldUpdate =
      octaneData?.getAttribute("data-update-shade-match") === "true";
    const blocks = e?.detail?.product_blocks;
    const quizProduct = Array.isArray(blocks)
      ? blocks.flat().find((item) => item?.link)
      : null;

    try {
      const resultProduct = String(blocks?.[0]?.[0]?.id || blocks?.[1]?.[0]?.id);

      let priceElements = document.querySelectorAll('.oct-quiz-products__item .oct-quiz-result-item__pricing');
      if (!priceElements.length) {
        priceElements = document.querySelectorAll('div[data-element="oct-quiz-resultitem"] div:nth-child(2) div:nth-child(4)');
      }

      const resultProducts = Array.isArray(blocks?.[0]) ? blocks[0] : [];
      const fallbackProduct = blocks?.[1]?.[0];

      if (resultProducts.length && priceElements.length) {
        renderPrices(resultProducts, priceElements);
      } else if (fallbackProduct && priceElements[0]) {
        renderPrices(fallbackProduct, priceElements);
      }

      let variantId;
      let quizType;
      let maxQuant;

      const dataTag = document.querySelector('.octane-data script[data-product-variant-metafields-json]');
      if (!dataTag) throw new Error("Data script tag not found");

      const allProducts = JSON.parse(dataTag.textContent.trim());

      let selectedProduct = null;
      const resultProductId = String(resultProduct);
      for (const productId in allProducts) {
        const productData = allProducts[productId];

        //ID matches product ID
        if (String(productData.product.id) === resultProductId) {
          selectedProduct = productData;
          quizType = 'productMatch';
          const vData = Object.keys(productData.variants || {});
          variantId = Number(vData[0]);
          break;
        }

        //ID matches one of the variant IDs
        const variantIds = Object.keys(productData.variants || {});
        if (variantIds.includes(resultProductId)) {
          quizType = 'shadeFinder';
          variantId = resultProductId;
          selectedProduct = productData;
          break;
        }
      }

      if (!selectedProduct) throw new Error(`Product not found for variant: ${resultProductId}`);

      const formatMetafields = (val) => val === null ? "null" : val;
      const result = {
        product: {
          id: selectedProduct.product.id,
          handle: selectedProduct.product.handle,
          title: selectedProduct.product.title,
          metafields: {
            max_quantity: formatMetafields(selectedProduct.product.metafields.max_quantity),
            bundle_set_handles: selectedProduct.product.metafields.bundle_set_handles || ""
          }
        },
        variants: {}
      };

      for (const [id, variant] of Object.entries(selectedProduct.variants)) {
        result.variants[id] = {
          title: variant.title,
          shade_name: variant.shade_name || "",
          max_quantity: formatMetafields(variant.max_quantity)
        };
      }

      const newScript = document.createElement('script');
      newScript.type = 'application/json';
      newScript.setAttribute('data-product-variant-metafields-json', '');
      newScript.textContent = JSON.stringify(result, null, 2);
      document.body.appendChild(newScript);

      if (quizType == 'shadeFinder') {
        let rawMax = result.variants[resultProductId]?.max_quantity;
        maxQuant = rawMax && rawMax !== 'null' ? Number(rawMax) : SHOP_DEFAULT_MAX;
      } else {
        let rawMax = result.product.metafields?.max_quantity;
        maxQuant = rawMax && rawMax !== 'null' ? Number(rawMax) : SHOP_DEFAULT_MAX;
      }

      const prodName = `${result.product.title} - ${result.variants[variantId]?.title}`;
      const inCartQty = await window.getVariantQuantityInCart(variantId);

      setTimeout(() => {
        if (inCartQty >= maxQuant) {
        const msgEl = document.querySelector('.max-qty-msg');
        if (msgEl) msgEl.remove();

        const AddToCartButton = document.querySelector('#octane-quiz-outer-wrapper button');
        if (AddToCartButton) {
          AddToCartButton.disabled = true;
          AddToCartButton.setAttribute('disabled', 'disabled');
          AddToCartButton.classList.add('is-disabled');
          AddToCartButton.style.cursor = 'not-allowed';
          AddToCartButton.style.opacity = '0.5';
          insertLimitMessage(prodName, maxQuant);
        }
      }
      })
    } catch (error) {
      console.error('Error building product JSON:', error);
    }

    if (shadeMatch && shouldUpdate && quizProduct?.link) {
      try {
        const url = getProductFetchUrlStr(quizProduct?.link);
        if (!url) return;
        fetch(url)
          .then((res) => {
            if (!res.ok) throw new Error("Network response not ok");
            return res.text();
          })
          .then((text) => {
            const data = JSON.parse(text);
            const variant = data?.product?.variants?.find(
              (v) => v.id == quizProduct.id
            );
            if (variant) {
              const detail = {
                handle: data.product.handle || "",
                barcode: variant.barcode || "",
                featureID: "quiz",
              };
              document.body.dispatchEvent(
                new CustomEvent("shadeMatch:setData", { detail })
              );
            }
          })
          .catch((err) =>
            console.error("Error during fetch or processing:", err)
          );
      } catch (err) {
        console.error("Unexpected error:", err);
      }
    }
  },
  false
);

// add more information to undertones quiz step
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("octane.quiz.questionLoaded", function (event) {
    const questionID = event.detail.question_id;
    const quizWrapperElement = event.detail.quiz_wrapper_element;

    const fairUndertonesID = "45e0f87482e48cd02116ca82aefbb16aeec5e1a3";
    const richUndertonesID = "2c342daaeb8426bee74fd2478b740fc79daec072";

    const fairUndertoneDetails = {
      neutral: {
        sun: "burn first, then tan",
        jewelry: "both silver & gold",
        veins: "blue",
      },
      beige: {
        sun: "burn first, then tan",
        jewelry: "both silver & gold",
        veins: "blue or purple",
      },
      sand: {
        sun: "burn first, then tan",
        jewelry: "both silver & gold",
        veins: "green with hints of blue",
      },
      honey: {
        sun: "tan effortlessly, rarely burn",
        jewelry: "gold",
        veins: "bluish purple",
      },
      golden: {
        sun: "tan quickly, hardly ever burn",
        jewelry: "gold",
        veins: "green",
      },
    };

    const richUndertoneDetails = {
      neutral: {
        sun: "burn first, then tan",
        jewelry: "both silver & gold",
        veins: "blue",
      },
      warm: {
        sun: "tan easily, rarely burn",
        jewelry: "gold",
        veins: "blueish purple",
      },
      sand: {
        sun: "burn first, then tan",
        jewelry: "both silver & gold",
        veins: "green with hints of blue",
      },
      honey: {
        sun: "tan effortlessly, rarely burn",
        jewelry: "gold",
        veins: "bluish purple",
      },
      golden: {
        sun: "tan quickly, hardly ever burn",
        jewelry: "gold",
        veins: "green",
      },
    };

    if (questionID === fairUndertonesID || questionID === richUndertonesID) {
      setTimeout(() => {

        const undertoneDetails = questionID === fairUndertonesID ? fairUndertoneDetails : richUndertoneDetails;

        // Select all <li> options
        const options = quizWrapperElement.querySelectorAll(
          ".oct-quiz-multiple-choice-options__option"
        );

        options.forEach((option) => {
          const standardImageContainer = option.querySelector(
            "div.standard_image_container"
          );
          standardImageContainer.classList.add("undertones");
          const labelEl = option.querySelector(
            "div.standard_image_container > div:last-child"
          );
          const undertoneSwatchImg = option.querySelector(
            "div.standard_image_container > div:first-child"
          );
          undertoneSwatchImg.classList.add("undertone-swatch");
          standardImageContainer
            .querySelector("div:nth-child(2)")
            .classList.add("undertone-title");
          if (!labelEl) return;

          const label = labelEl.textContent.trim().toLowerCase();
          const details = undertoneDetails[label];

          if (details && !option.querySelector(".undertone")) {
            const detailEl = document.createElement("div");
            detailEl.className = "undertone";
            detailEl.innerHTML = `
			  <small>
				<span class='undertone-details__header'>sun:</span> <span class='undertone-details__content'>${details.sun}</span><br>
				<span class='undertone-details__header'>best jewelry:</span> <span class='undertone-details__content'>${details.jewelry}</span><br>
				<span class='undertone-details__header'>veins:</span> <span class='undertone-details__content'>${details.veins}</span>
			  </small>
			`;
            labelEl.parentNode.appendChild(detailEl);
          }
        });
      }, 300);
    }
  });
});

function fetchCartSections(sections = ['cart-drawer', 'cart-icon-bubble']) {
  const root = window.Shopify.routes?.root || '';
  const localePrefix = root.endsWith('/') ? root.slice(0, -1) : root; // remove trailing slash if present

  const params = new URLSearchParams();
  params.append('sections', sections.join(','));

  return fetch(`${localePrefix}/?${params.toString()}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then((res) => {
    if (!res.ok) throw new Error(`Sections request failed: ${res.status}`);
    return res.json();
  });
}

document.addEventListener('octane.quiz.addToCart', function (e) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  fetchCartSections(['cart-drawer', 'cart-icon-bubble'])
    .then((sections) => {
      cart?.renderContents({ sections });
    })
    .catch((err) => {
      console.error('Failed to refresh cart drawer:', err);
    });
}, false);

